import script from "./CohortPageCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./CohortPageCarousel.vue?vue&type=script&setup=true&lang=js"

import "./CohortPageCarousel.vue?vue&type=style&index=0&id=1c38da0d&scoped=true&lang=scss"
/* custom blocks */
import block0 from "../locales/en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ffb%2Fapp%2Fwebpack%2Fcomponents%2FCohortPageCarousel.vue&global=true&external"
if (typeof block0 === 'function') block0(script)
import block1 from "../locales/fr.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ffb%2Fapp%2Fwebpack%2Fcomponents%2FCohortPageCarousel.vue&global=true&external"
if (typeof block1 === 'function') block1(script)
import block2 from "../locales/es.json?vue&type=custom&index=2&blockType=i18n&issuerPath=%2Ffb%2Fapp%2Fwebpack%2Fcomponents%2FCohortPageCarousel.vue&global=true&external"
if (typeof block2 === 'function') block2(script)
import block3 from "../locales/it.json?vue&type=custom&index=3&blockType=i18n&issuerPath=%2Ffb%2Fapp%2Fwebpack%2Fcomponents%2FCohortPageCarousel.vue&global=true&external"
if (typeof block3 === 'function') block3(script)
import block4 from "../locales/pt.json?vue&type=custom&index=4&blockType=i18n&issuerPath=%2Ffb%2Fapp%2Fwebpack%2Fcomponents%2FCohortPageCarousel.vue&global=true&external"
if (typeof block4 === 'function') block4(script)
import block5 from "../locales/de.json?vue&type=custom&index=5&blockType=i18n&issuerPath=%2Ffb%2Fapp%2Fwebpack%2Fcomponents%2FCohortPageCarousel.vue&global=true&external"
if (typeof block5 === 'function') block5(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c38da0d"]])

export default __exports__